import React, { FunctionComponent, useState, useEffect } from "react";
import SearchPageProps from "./SearchPageProps.interface";
import styles from "./SearchPage.module.scss";
import fetchSearchResults from "./helpers/fetchSearchResults";
import ResultCard from "./components/ResultCard/ResultCard";
import useDebounce from "./hooks/useDebounce";

const SearchPage: FunctionComponent<SearchPageProps> = (props) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [items, setItems] = useState<any[] | undefined>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        searchQuery.length > 0 ? setLoading(true) : setLoading(false);
        if(searchQuery.length === 0) setItems([]);
    }, [searchQuery]);

    const fetchResults = async () => {
        setLoading(false);
        const fetchedItems = await fetchSearchResults(searchQuery);
        setItems(fetchedItems);
    };

    useDebounce(searchQuery, 500, fetchResults);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setSearchQuery(e.target.value);
    };

    return (
        <section className={styles.wrapper} >
            <div className={styles.container} >
                <h1 className={styles.page_title}>{props.pageTitle ? props.pageTitle : "Search Page"}</h1>
                <input type="text" className={styles.search_bar} value={searchQuery} onChange={handleInputChange}/>

                <div className={styles.results}>
                    {loading ? (
                        <div>
                            <div className={styles.loader}>Loading...</div>
                        </div>
                    ): null}
                    {!loading && items && items.map((item: any) => {
                        return (
                            <ResultCard key={item.content._id} {...item} />
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SearchPage;